const config = {
  development: {
    baseURL: "http://localhost:8080/api",
    docsURL: "http://localhost:8080/docs",
    uploadsPath: "http://localhost:8080/uploads/", // Centralized uploads path for dev
  },
  production: {
    baseURL: "/api",
    docsURL: "/docs",
    uploadsPath: "/uploads/", // Use URL path for prod
  },
};

const environment = process.env.NODE_ENV || "production";
export const apiConfig = config[environment];
